(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('userqualityHeader', userqualityHeader);

    function userqualityHeader() {
        return {
            templateUrl: '/app/directives/userquality-header.tpl.html',
            scope: {
                item: '=',
                exemptionEditable: '=',
                notNecessaryEditable: '='
            },
            controller: UserqualityHeaderController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function UserqualityHeaderController($state, $stateParams, logger, modalDialogService, dataService) {
        var vm = this;
        
        vm.deleteExemption = deleteExemption;
        vm.editExemption = editExemption;
        vm.exemptionHasAssets = exemptionHasAssets;
        vm.exemptionHasDescription = exemptionHasDescription;
        vm.showAssetsDialog = showAssetsDialog;
        vm.toggleNotNecessary = toggleNotNecessary;

        function deleteExemption() {
            return dataService
                .deleteExemption(vm.item.id)
                .then(response => {
                    logger.success('successfully_deleted');
                    vm.buttonsDisabled = false;
                });
        }

        function editExemption() {
            return modalDialogService.openExemptionDialog(vm.item);
        }
        
        function exemptionHasAssets() {
            return vm.item.exemption && vm.item.exemption.exemptionAssets && vm.item.exemption.exemptionAssets.length;
        }

        function exemptionHasDescription() {
            return vm.item.exemption && vm.item.exemption.dateOfExpiry && vm.item.exemption.description.length;
        }

        function showAssetsDialog() {
            modalDialogService.openAssetsDownloadDialog(vm.item);
        }

        function toggleNotNecessary() {
            dataService.saveNotNecessary(vm.item, !vm.item.notNecessary).then(response => { logger.success('successfully_saved'); });
        }
    }
})();